<div>
    <form [formGroup]="advertiserGroupForm" class="category-content">
        <div class="data-container">
            <span class="data-title"> Statut Annonceur * </span>
            <div class="tv-rect-input-small-no-label full-width">
                <mat-form-field>
                    <input matInput formControlName="advertiserStatus" [matAutocomplete]="autoAdvertiserStatus" />
                    <mat-error class="error" *ngIf="advertiserGroupForm.get('advertiserStatus')?.hasError('required')">
                        Veuillez choisir un statut annonceur
                    </mat-error>
                    <mat-autocomplete
                        autoActiveFirstOption
                        class="tv-custom-always-visible-scroll-bar"
                        #autoAdvertiserStatus="matAutocomplete"
                        [displayWith]="displayAutoCompleteData">
                        <mat-option
                            *ngFor="let advertiserStatus of filteredAdvertiserStatusList | async"
                            class="tv-ns-select-option"
                            [value]="advertiserStatus">
                            {{ advertiserStatus.name }} - {{ advertiserStatus.id }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>

        <div class="data-container">
            <span class="data-title"> Secteur * </span>
            <div class="tv-rect-input-small-no-label full-width">
                <mat-form-field>
                    <input matInput formControlName="sector" [matAutocomplete]="autoSector" />
                    <mat-error class="error" *ngIf="advertiserGroupForm.get('sector')?.hasError('required')">
                        Veuillez choisir un secteur
                    </mat-error>
                    <mat-autocomplete
                        autoActiveFirstOption
                        class="tv-custom-always-visible-scroll-bar"
                        #autoSector="matAutocomplete"
                        [displayWith]="displayAutoCompleteData">
                        <mat-option
                            *ngFor="let contractSector of filteredContractSectorList | async"
                            class="tv-ns-select-option"
                            [value]="contractSector">
                            {{ contractSector.name }} - {{ contractSector.id }}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
